<div class="pageheader">
    <div class="page-title">
        <h1>Search Status Events Result</h1>
        <div class="btn-group" data-toggle="buttons">
            <button class="btn btn-link" (click)="refresh()" id="saveButton">
                Refresh Data <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
        </div>
    </div>
</div>

<app-status-events-master-grid [dataSourceItems]="$safeNavigationMigration(stateObject?.SearchStatusEventItems)" (onRefreshEvent)="refresh()"></app-status-events-master-grid>